import { createInertiaApp } from "@inertiajs/react";
import { createRoot } from "react-dom/client";
import "../styles/application.css";

createInertiaApp({
  title: (title) => (title ? `${title} · Court Pilot` : "Court Pilot"),
  resolve: (name) => {
    const pages = import.meta.glob("../pages/**/*.tsx", { eager: true });
    const page = pages[`../pages/${name}.tsx`];
    if (!page) throw new Error(`Inertia page not found: ${name}`);
    return page as never;
  },
  setup({ el, App, props }) {
    createRoot(el).render(<App {...props} />);
  },
});

// Register the service worker so Android offers "install" and a lost
// connection shows our page rather than the browser's error. Failure is
// silent: it is an enhancement, never a requirement for the app to run.
if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/service-worker.js").catch(() => {});
  });
}
